<template>
	<div
		class="time-picker"
		:class="{
			'time-picker--disabled': disabled,
			'time-picker--empty': !times.length,
			'time-picker--no-selection': !value,
			'time-picker--single-col': singleCol,
		}"
	>
		<FormInputSelect
			:value="value"
			:options="enhancedTimes"
			:disabled="disabled"
			:readonly="readonly"
			:label="label"
			:hint="hint"
			:error="error"
			:error-message="errorMessage"
			:success="success"
			:success-message="successMessage"
			@input="onInput"
		/>
	</div>
</template>

<script>
import FormInputSelect from '@/components/FormInputSelectCustom';

export default {
	components: {
		FormInputSelect
	},
	props: {
		disabled: Boolean,
		readonly: Boolean,
		singleCol: Boolean,
		label: String,
		value: {
			default: "12:00"
		},
		times: {
			type: Array
		},
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	data() {
		return {

		}
	},
	computed: {
		enhancedTimes() {
			return this.times
				? this.times
					.map(t => {
						if (t instanceof Object) {
							return {
								...t,
								label: t.label || t.value,
								disabled: false,
							}
						}
						return {
							value: t,
							label: t,
							disabled: false,
						}
					})
				: []
		}
	},
	methods: {
		onInput(value) {
			this.$emit('input', value);
		},
	}
}
</script>

<style>

</style>
